import {getOutlet, hasOutlet} from 'reconnect.js';

export function getCategoryInstance(name) {
  if (!hasOutlet('site')) {
    return false;
  }
  const site = getOutlet('site').getValue();
  if (!Array.isArray(site)) {
    return false;
  }
  const config = site.find((s) => s.name === name);
  return config;
}

export function getCategories(name) {
  const config = getCategoryInstance(name);
  if (config) {
    return config.categories || [];
  }
  return [];
}

export function getFlattenCategories(name) {
  const cats = getCategories(name);

  const result = [];

  if (Array.isArray(cats)) {
    for (const c1 of cats) {
      result.push(c1);
      if (Array.isArray(c1.items)) {
        for (const c2 of c1.items) {
          result.push(c2);
          if (Array.isArray(c2.items)) {
            for (const c3 of c2.items) {
              result.push(c3);
            }
          }
        }
      }
    }
  }

  return result;
}
